import SurveyLocationHierarchy from "./SurveyLocationHierarchy";

export default SurveyLocationHierarchy;
